export const isString = (input) => typeof input === "string";
export const includes = (haystack, needle) => haystack.indexOf(needle) !== -1;
